const hideBannerPostChangeHdfcOrgList = [
    "HPORG201810171255207671191417HP",
    "HPORG201810231335185509087256HP", 
    "HPORG20181211950382724019471HP", 
    "HPORG20181261012238810835185HP", 
    "HPORG20187575514842954563HP", 
    "HPORG2018814654389592233079HP", 
    "HPORG20188171115511128721410HP", 
    "HPORG2018827120115451096441HP", 
    "HPORG2018925813388763015623HP", 
    "HPORG20191018529129636694522HP", 
    "HPORG20191125626521732462932HP", 
    "HPORG20191227643329875191104HP", 
    "HPORG2019125125747793195391HP", 
    "HPORG201912593615752146941HP", 
    "HPORG201912810584187892765HP", 
    "HPORG2019129825467306012983HP", 
    "HPORG2019221110454024765695HP", 
    "HPORG201932546351869349721HP", 
    "HPORG20194291257222260983287HP", 
    "HPORG2019512757317420787453HP", 
    "HPORG201951313238373913692HP", 
    "HPORG2019523742461749156261HP", 
    "HPORG2019618147331678353601HP", 
    "HPORG20196191029169468115467HP", 
    "HPORG20196276799460811757HP", 
    "HPORG2019712112727441157230HP", 
    "HPORG2019724452397802999622HP", 
    "HPORG2019821815246286319393HP", 
    "HPORG2019875812533695240HP", 
    "HPORG2019920715221544153080HP", 
    "HPORG20199241223142836969019HP", 
    "HPORG2019927113981593192321HP", 
    "HPORG2020111115434620834920HP", 
    "HPORG2020122131313264937080HP", 
    "HPORG20201285332167634912HP", 
    "HPORG2020130103098522356197HP", 
    "HPORG2020130742153165463574HP", 
    "HPORG202013091236176383827HP", 
    "HPORG202013548433195191370HP", 
    "HPORG202021275225617937665HP", 
    "HPORG2020213115474402459693HP", 
    "HPORG20202261012535168512375HP", 
    "HPORG202039649144910239149HP", 
    "HPORG2020417128509845392057HP", 
    "HPORG202046126199319417633HP", 
    "HPORG2020610755374387102158HP", 
    "HPORG202072894938046655044HP", 
    "HPORG2020817538466217246102HP", 
    "HPORG2020914127286704461218HP", 
    "HPORG20213311222435122276976HP", 
    "HPORG20213311232419682643388HP", 
    "HPORG2019923955231257226618HP",
    "HPORG2023113122301318188822HP"
];

export default hideBannerPostChangeHdfcOrgList;